export enum PermissionLevelCode {
    EDITOR = "E",
}